<div class="container" [ngSwitch]="mode">

    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>S/N</th>
          <th>Bar Code</th>
          <th>
            <button class="add" mat-raised-button color="basic" (click)="addNew()">
              Add New
            </button>
          </th>
        </tr>
        <tr class="td" *ngFor="let title of titles">
          <td>{{title.id}}</td>
          <td>{{title.barcode_no}}</td>
          <td>
            <button mat-raised-button color="primary" (click)=" edit(title)">
              Edit
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create Sales Card</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Employee</mat-label>
                <mat-select formControlName="employee_id" matNativeControl required>
                  <mat-option *ngFor="let employee of employees" [value]="employee.id">
                    {{employee.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Branch</mat-label>
                <mat-select formControlName="branch_code" matNativeControl required>
                  <mat-option *ngFor="let branch of branches" [value]="branch.Id">
                    {{branch.Branch_Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Fin Year</mat-label>
                <input formControlName="fin_year" matInput placeholder="2020-2022">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Card Type</mat-label>
                <mat-select formControlName="card_type" matNativeControl required>
                  <mat-option *ngFor="let type of types" [value]="type">
                    {{type}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Bar Code</mat-label>
                <input formControlName="barcode_no" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Card Comm</mat-label>
                <input formControlName="card_comm" matInput placeholder="Imo">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field class="size">
                <mat-label>Date From</mat-label>
                <input formControlName="date_from" matInput [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </span>
            <span class="input">
                <mat-form-field class="size">
                    <mat-label>Date To</mat-label>
                    <input formControlName="date_to" matInput [matDatepicker]="to">
                    <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
            </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit Sales Card</div>
        <div class="form">
            <span class="input">
                <mat-form-field>
                    <mat-label>Employee</mat-label>
                    <mat-select formControlName="employee_id" matNativeControl required>
                      <mat-option *ngFor="let employee of employees" [value]="employee.id">
                        {{employee.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Branch</mat-label>
                    <mat-select formControlName="branch_code" matNativeControl required>
                      <mat-option *ngFor="let branch of branches" [value]="branch.Id">
                        {{branch.Branch_Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Fin Year</mat-label>
                    <input formControlName="fin_year" matInput placeholder="2020-2022">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Card Type</mat-label>
                    <mat-select formControlName="card_type" matNativeControl required>
                      <mat-option *ngFor="let type of types" [value]="type">
                        {{type}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Bar Code</mat-label>
                    <input formControlName="barcode_no" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                    <mat-label>Card Comm</mat-label>
                    <input formControlName="card_comm" matInput placeholder="Imo">
                  </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field class="size">
                    <mat-label>Date From</mat-label>
                    <input formControlName="date_from" matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field class="size">
                        <mat-label>Date To</mat-label>
                        <input formControlName="date_to" matInput [matDatepicker]="to">
                        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div> 
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    
     
    </div>